const KNOWN_CITY_SLUGS = new Set([
  'paris',
  'lyon',
  'marseille',
  'toulouse',
  'lille',
  'bordeaux',
  'nantes',
  'strasbourg',
  'montpellier',
  'nice',
  'rennes',
  'reims',
  'saint-etienne',
  'toulon',
  'grenoble',
  'dijon',
  'angers',
  'nimes',
  'villeurbanne',
  'clermont-ferrand',
]);

export function isKnownCitySlug(slug) {
  return KNOWN_CITY_SLUGS.has(String(slug || '').toLowerCase());
}

export function parseConvoyagePath(pathname) {
  const cleanedPath = String(pathname || '').split('?')[0];
  if (!cleanedPath.startsWith('/convoyage/')) {
    return { type: 'none' };
  }

  const slug = cleanedPath.replace('/convoyage/', '').trim().toLowerCase();
  if (!slug) {
    return { type: 'none' };
  }

  const parts = slug.split('-').filter(Boolean);
  if (parts.length < 2) {
    return { type: 'city', citySlug: slug };
  }

  // We only consider this slug a route when both inferred cities are known.
  // This avoids misclassifying city names like "saint-etienne" as "saint" -> "etienne".
  for (let splitIndex = 1; splitIndex < parts.length; splitIndex += 1) {
    const fromSlug = parts.slice(0, splitIndex).join('-');
    const toSlug = parts.slice(splitIndex).join('-');
    if (isKnownCitySlug(fromSlug) && isKnownCitySlug(toSlug) && fromSlug !== toSlug) {
      return {
        type: 'route',
        fromSlug,
        toSlug,
      };
    }
  }

  return { type: 'city', citySlug: slug };
}

export function normalizeConvoyageCanonicalPath(pathname) {
  const rawPath = String(pathname || '/');
  if (rawPath.startsWith('/convoyage-')) {
    const citySlug = rawPath.replace('/convoyage-', '').trim();
    return citySlug ? `/convoyage/${citySlug}` : '/convoyage';
  }

  if (rawPath.startsWith('/transport-')) {
    const routeSlug = rawPath.replace('/transport-', '').trim();
    return routeSlug ? `/convoyage/${routeSlug}` : '/convoyage';
  }

  return rawPath;
}
